import React from 'react';
import { Calendar } from 'lucide-react';

interface DateRangePickerProps {
  startDate: string;
  endDate: string;
  onStartDateChange: (val: string) => void;
  onEndDateChange: (val: string) => void;
}

const PRESETS: { label: string; fn: () => { start: string; end: string } }[] = [
  { label: 'Last 30d', fn: () => ({ start: daysAgo(30), end: today() }) },
  { label: 'Last 90d', fn: () => ({ start: daysAgo(90), end: today() }) },
  { label: '6 Months', fn: () => ({ start: daysAgo(180), end: today() }) },
  { label: '1 Year', fn: () => ({ start: daysAgo(365), end: today() }) },
  { label: 'This Month', fn: () => ({ start: firstOfMonth(), end: today() }) },
  { label: 'This Year', fn: () => ({ start: `${new Date().getFullYear()}-01-01`, end: today() }) },
];

function getLocalDateString(d: Date) {
  const pad = (n: number) => n.toString().padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
function today() { return getLocalDateString(new Date()); }
function daysAgo(n: number) { const d = new Date(); d.setDate(d.getDate() - n); return getLocalDateString(d); }
function firstOfMonth() { const d = new Date(); d.setDate(1); return getLocalDateString(d); }

const DateRangePicker: React.FC<DateRangePickerProps> = ({ startDate, endDate, onStartDateChange, onEndDateChange }) => (
  <div className="space-y-3">
    <div className="flex items-center gap-2 text-sm font-medium text-gray-700 dark:text-gray-300">
      <Calendar className="h-4 w-4 text-primary-500" /> Date Range
    </div>
    <div className="grid grid-cols-2 gap-3">
      <div>
        <label className="block text-xs text-gray-500 dark:text-gray-400 mb-1">From</label>
        <input type="date" value={startDate} onChange={e => onStartDateChange(e.target.value)}
          className="form-input text-sm w-full" />
      </div>
      <div>
        <label className="block text-xs text-gray-500 dark:text-gray-400 mb-1">To</label>
        <input type="date" value={endDate} onChange={e => onEndDateChange(e.target.value)}
          className="form-input text-sm w-full" />
      </div>
    </div>
    <div className="flex flex-wrap gap-1.5">
      {PRESETS.map(p => (
        <button key={p.label}
          onClick={() => { const r = p.fn(); onStartDateChange(r.start); onEndDateChange(r.end); }}
          className="px-2.5 py-1 text-[11px] font-medium rounded-full border border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-300 hover:bg-primary-50 dark:hover:bg-primary-900/20 hover:border-primary-400 hover:text-primary-700 dark:hover:text-primary-300 transition-colors"
        >{p.label}</button>
      ))}
    </div>
  </div>
);

export default DateRangePicker;
